<div class="frame-solid wj-tabpane">

  <div class="block-row">
    <div class="image-container">
      <img id="img_GoodsImage" src="{{goodsImagePreviewURL}}">
    </div>

    <div class="detail-container element-column">
      <app-kymw1407-image-info-detail-box id="imageInfoDetailBox" #imageInfoDetailBox forcedEnabledMode="true"
        [style.width.%]="100"
        (eventImageInfoDetailCHANGE)="eventImageInfoDetailCHANGE.emit($event)"
        (changeStartOrderCode)="changeStartOrderCode.emit($event)"
        (changeEndOrderCode1)="changeEndOrderCode1.emit($event)"
        (changeEndOrderCode2)="changeEndOrderCode2.emit($event)">
      </app-kymw1407-image-info-detail-box>

      <div class="layout_balance">
        <button id="btn_Reset" forcedEnabledMode="none" [tabindex]="-1" class="btn-tartiary"
          [disabled]="disabledResetBtn" (click)="eventResetCLICK.emit()">リセット</button>
        <div class="element-row">
          <button id="btn_UseStop" forcedEnabledMode="none" [tabindex]="-1" class="btn-secondary"
            [disabled]="disabledUseStopBtn" (click)="eventUseStopCLICK.emit()">使用停止</button>

          <button id="btn_Setting" forcedEnabledMode="none" [tabindex]="-1" class="btn-primary"
            [disabled]="disabledSettingBtn" (click)="eventSettingCLICK.emit()">設定</button>
        </div>
      </div>
    </div>
  </div>

</div>
